<template>
  <div>
    <div
      v-for="(safe,sIndex) in dataList"
      :key="safe.id"
    >
      <b-card-header>
        <b-card-title>
          <div class="mb-1">
            {{ safe.title }}
          </div>
          <b-card-sub-title>
            Gelir&Gider Bakiye Raporu
          </b-card-sub-title>
        </b-card-title>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col>
            <total-card
              card-title="Gelirler Toplamı"
              card-color="success"
              card-icon="CheckCircleIcon"
              :card-amount="safe.income_amount"
            />
          </b-col>
          <b-col>
            <total-card
              card-title="Giderler Toplamı"
              card-color="danger"
              card-icon="XCircleIcon"
              :card-amount="safe.expense_amount"
            />
          </b-col>
          <b-col>
            <total-card
              card-title="Güncel Bakiye"
              card-color="primary"
              card-icon="CheckCircleIcon"
              :card-amount="safe.total_amount"
            />
          </b-col>
          <b-col>
            <total-card
              card-title="Devir Toplamı"
              card-color="info"
              card-icon="RefreshCwIcon"
              :card-amount="safe.carryover_amount"
            />
          </b-col>
        </b-row>
      </b-card-body>
      <b-table-simple
        borderless
        striped
        responsive="sm"
        class="mb-0"
      >
        <b-thead>
          <b-tr>
            <b-th
              class="text-center width-50"
            >
              <FeatherIcon icon="EyeIcon" />
            </b-th>
            <b-th>Tanım</b-th>
            <b-th class="width-200 text-right text-nowrap">
              Gelirler Toplamı
            </b-th>
            <b-th class="width-200 text-right text-nowrap">
              Giderler Toplamı
            </b-th>
            <b-th class="width-200 text-right text-nowrap">
              Güncel Bakiye
            </b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <template
            v-for="(type,tIndex) in safe.types"
          >
            <b-tr
              :key="type.id + '_' + tIndex"
              class="text-secondary"
            >
              <b-td>
                <b-button
                  :variant="type.toggle? 'flat-danger' : 'flat-success'"
                  pill
                  class="btn-icon"
                  @click="toggleDetail(sIndex,tIndex)"
                >
                  <FeatherIcon :icon="type.toggle? 'EyeOffIcon' : 'EyeIcon'" />
                </b-button>
              </b-td>
              <b-td>
                {{ type.title }}
                <div class="font-small-2 text-warning">
                  {{ type.donation_type }}
                </div>
              </b-td>
              <b-td class="text-right text-nowrap font-weight-bold text-success">
                {{ type.income_amount | toCurrency }} TL
              </b-td>
              <b-td class="text-right text-nowrap font-weight-bold text-danger">
                {{ type.expense_amount | toCurrency }} TL
              </b-td>
              <b-td class="text-right text-nowrap font-weight-bold text-primary">
                {{ type.total_amount | toCurrency }} TL
              </b-td>
            </b-tr>
            <template
              v-for="subitem in type.items"
            >
              <b-tr
                v-if="type.toggle"
                :key="subitem.id + '_' + sIndex + '_' + tIndex"
                class="text-secondary"
              >
                <b-td />
                <b-td>
                  {{ subitem.title }}
                  <div class="font-small-2 text-warning">
                    {{ subitem.donation_type }}
                  </div>
                </b-td>
                <b-td class="text-right text-nowrap font-weight-bold text-success">
                  <div v-if="subitem.is_income">
                    {{ subitem.income_amount | toCurrency }} TL
                  </div>
                </b-td>
                <b-td class="text-right text-nowrap font-weight-bold text-danger">
                  <div v-if="subitem.is_expense">
                    {{ subitem.expense_amount | toCurrency }} TL
                  </div>
                </b-td>
                <b-td class="text-right text-nowrap font-weight-bold text-primary">
                  {{ subitem.total_amount | toCurrency }} TL
                </b-td>
              </b-tr>
            </template>
          </template>
        </b-tbody>
        <b-tfoot>
          <b-tr>
            <b-th />
            <b-th>
              Genel Toplam
            </b-th>
            <b-th class="text-right text-nowrap">
              {{ grandTotal.income_amount | toCurrency }} TL
            </b-th>
            <b-th class="text-right text-nowrap">
              {{ grandTotal.expense_amount | toCurrency }} TL
            </b-th>
            <b-th class="text-right text-nowrap">
              {{ grandTotal.total_amount | toCurrency }} TL
            </b-th>
          </b-tr>
        </b-tfoot>
      </b-table-simple>
    </div>
  </div>
</template>
<script>
import {
  BCardHeader,
  BCardTitle,
  BCardBody,
  BRow,
  BCol,
  BTableSimple,
  BThead,
  BTbody,
  BTr,
  BTh,
  BTd,
  BTfoot,
  BButton, BCardSubTitle,
} from 'bootstrap-vue'
import TotalCard from '@/views/Admin/Reports/Banks/components/TotalCard.vue'

export default {
  name: 'ReportTable',
  components: {
    BCardSubTitle,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BRow,
    BCol,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
    BTfoot,
    BButton,
    TotalCard,
  },
  computed: {
    dataList() {
      return this.$store.getters['safesReports/dataList']
    },
    grandTotal() {
      return this.$store.getters['safesReports/grandTotal']
    },
  },
  methods: {
    toggleDetail(sIndex, index) {
      this.dataList[sIndex].types[index].toggle = !this.dataList[sIndex].types[index].toggle
    },
  },
}
</script>
